<template>
    <div class="shop-dark-wrapper px-4 px-sm-6 px-md-10">
        <!-- Header Section -->
        <div class="d-flex align-center py-5 mb-6 animate-fade-in-up stagger-1" style="border-bottom: 1px solid rgba(255, 255, 255, 0.08);">
            <v-btn class="premium-btn-icon-circle mr-4" icon @click="$router.push('/user')">
                <v-icon color="white">mdi-chevron-left</v-icon>
            </v-btn>
            <h1 class="premium-title-gradient text-h5 font-weight-black mb-0">Deine Einkäufe</h1>
        </div>

        <!-- Purchases List -->
        <v-row v-if="purchases && purchases.length" class="animate-fade-in-up stagger-2">
            <v-expansion-panels v-model="purchasesModel" dark class="premium-panels">
                <v-expansion-panel 
                    v-for="(purchase, i) of purchases" 
                    :key="i + '-purchaseIndex'"
                    class="glass-card mb-4 overflow-hidden"
                >
                    <v-expansion-panel-header class="py-5 px-6 white--text font-weight-bold">
                        <div class="d-flex align-center justify-space-between width-100 pr-4">
                            <div>
                                <span class="grey--text text--lighten-1 text-caption d-block mb-1">Einkauf vom</span>
                                <span class="text-subtitle-1">{{ $moment(purchase.createdAt).format('DD.MM.YY [um] HH:mm') }} Uhr</span>
                            </div>
                            <div class="text-right">
                                <span class="grey--text text--lighten-1 text-caption d-block mb-1">Anzahl Produkte</span>
                                <span class="text-subtitle-1">{{ purchase.products.length }} {{ purchase.products.length > 1 ? 'Produkte' : 'Produkt' }}</span>
                            </div>
                        </div>
                        <template v-slot:actions>
                            <v-btn icon color="white" class="premium-btn-icon-circle mr-2" small @click.stop="pushToRoute(purchase)">
                                <v-icon size="18">mdi-eye-outline</v-icon>
                            </v-btn>
                        </template>
                    </v-expansion-panel-header>
                    
                    <v-expansion-panel-content class="px-2 pb-4">
                        <v-divider style="background-color: rgba(255,255,255,0.08)" class="mb-4"></v-divider>
                        
                        <div 
                            v-for="(product, index) of purchase.products" 
                            :key="'Product-' + index"
                            class="d-flex align-center justify-space-between pa-4 mb-2 rounded-xl"
                            style="background: rgba(0,0,0,0.15); border: 1px solid rgba(255, 255, 255, 0.03);"
                        >
                            <div>
                                <h4 class="white--text font-weight-bold mb-1">{{ product.title }}</h4>
                                <span style="color: #00B074; font-weight: 700; font-size: 0.95rem;">{{ product.price }} CHF</span>
                            </div>
                            
                            <v-btn icon color="white" class="premium-btn-icon-circle" small @click="getDownloadForProduct(purchase, index)">
                                <v-icon size="18">mdi-file-download-outline</v-icon>
                            </v-btn>
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-row>
        
        <!-- Empty State -->
        <v-row v-else class="justify-center mt-12 animate-fade-in-up stagger-2">
            <div class="glass-card pa-8 text-center" style="max-width: 500px; width: 100%;">
                <v-icon size="48" color="grey lighten-1" class="mb-4">mdi-ticket-outline</v-icon>
                <h3 class="text-h6 font-weight-bold white--text mb-2">Keine Einkäufe gefunden</h3>
                <p class="grey--text text--lighten-1 mb-0">Bisher wurden noch keine Gutscheine oder Abonnements mit diesem Account gekauft.</p>
            </div>
        </v-row>
    </div>
</template>
   
<script>
import api from '@/api'

export default {
    data() {
        return {
            purchasesModel: null,
            purchases: [],
        }
    },
    async created() {
        this.purchases = await api.fetchAllPurchasesDetails()
        if (!this.purchases || !this.purchases.length) {
            this.$toast.error('Es wurden keine Einkäufe gefunden.')
            this.$router.push('/user')
        }
    },
    methods: {
        pushToRoute(purchase) {
            this.$router.push('/shop/purchase/infos/' + purchase.transactionId)
            console.log(purchase)
        },
        async getDownloadForProduct(purchase, index) {
            this.$toast.success('Dein Ausdruck wird generiert')
            await api.downloadRealVoucher({ _id: purchase._id, product: index })
        }
    },
}
</script>

<style scoped>
@import './shopCommon.css';

.width-100 {
    width: 100%;
}

/* Custom visual updates to standard vuetify panels */
::v-deep .premium-panels .v-expansion-panel {
    background-color: var(--bg-card) !important;
}

::v-deep .premium-panels .v-expansion-panel::before {
    box-shadow: none !important;
}

::v-deep .premium-panels .v-expansion-panel-header__icon {
    margin-left: 8px !important;
}
</style>

  